import { useEffect, useMemo } from 'react'
import { Stack, useRouter, usePathname } from 'expo-router'
import { StatusBar } from 'expo-status-bar'
import CompetitionSwitcher from '../components/CompetitionSwitcher'
import CompetitionTransition from '../components/CompetitionTransition'
import { LOGO } from '../lib/assets'
import { View, Platform, StyleSheet, useWindowDimensions, Text, TouchableOpacity, Image } from 'react-native'
import { useFonts } from 'expo-font'
// Un import per ogni peso (non dal pacchetto intero): il pacchetto richiede tutti i suoi pesi e finirebbero tutti nel bundle
import { BarlowCondensed_400Regular } from '@expo-google-fonts/barlow-condensed/400Regular'
import { BarlowCondensed_500Medium } from '@expo-google-fonts/barlow-condensed/500Medium'
import { BarlowCondensed_700Bold } from '@expo-google-fonts/barlow-condensed/700Bold'
import { BarlowCondensed_800ExtraBold } from '@expo-google-fonts/barlow-condensed/800ExtraBold'
import * as SplashScreen from 'expo-splash-screen'
import * as Linking from 'expo-linking'
import { AuthProvider } from '../lib/AuthContext'
import { ThemeProvider } from '../lib/ThemeContext'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { GestureHandlerRootView } from 'react-native-gesture-handler'
import { useAuth } from '../lib/AuthContext'
import { useThemeColors } from '../lib/useThemeColors'
import { useBrandColors } from '../lib/ThemeContext'
import { fonts } from '../lib/theme'
import { supabase } from '../lib/supabase'
import Svg, { Path, Circle } from 'react-native-svg'
import '../lib/i18n'
import { BebasNeue_400Regular } from '@expo-google-fonts/bebas-neue/400Regular'
import { Orbitron_700Bold } from '@expo-google-fonts/orbitron/700Bold'
import { useTranslation } from 'react-i18next'
import UpdatePrompt from '../components/UpdatePrompt'

SplashScreen.preventAutoHideAsync()

// ── Icone ──────────────────────────────────────────────────────────
const IconHome = ({ size = 18, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <Path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" />
    <Path d="M9 21V12h6v9" />
  </Svg>
)
const IconPick = ({ size = 18, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <Path d="M12 20h9" />
    <Path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
  </Svg>
)
const IconTrophy = ({ size = 18, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <Path d="M6 9H4a2 2 0 01-2-2V5h4" />
    <Path d="M18 9h2a2 2 0 002-2V5h-4" />
    <Path d="M12 17v4" />
    <Path d="M8 21h8" />
    <Path d="M6 5h12v6a6 6 0 01-12 0V5z" />
  </Svg>
)
const IconLeagues = ({ size = 18, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <Path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <Circle cx="9" cy="7" r="4" />
    <Path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  </Svg>
)
const IconNews = ({ size = 18, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <Path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2" />
    <Path d="M18 14h-8M15 18h-5M10 6h8v4h-8z" />
  </Svg>
)
const IconUser = ({ size = 18, color }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <Path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
    <Circle cx="12" cy="7" r="4" />
  </Svg>
)

// ── Sidebar desktop ────────────────────────────────────────────────
function DesktopSidebar() {
  const tc = useThemeColors()
  const { brandColors } = useBrandColors()
  const { nickname, leagueName, userLeagues, switchLeague, signOut } = useAuth()
  const router = useRouter()
  const pathname = usePathname()

  const isActive = (route) => {
    if (route === '/') return pathname === '/' || pathname === '/index'
    return pathname.startsWith(route)
  }

  const { t } = useTranslation()

  const NAV_ITEMS = [
    { title: t('nav.home'), route: '/', icon: IconHome },
    { title: t('nav.pick'), route: '/pick', icon: IconPick },
    { title: t('nav.leaderboard'), route: '/leaderboard', icon: IconTrophy },
    { title: t('nav.leagues'), route: '/Leagues', icon: IconLeagues },
    { title: 'News', route: '/news', icon: IconNews },
    { title: t('nav.profile'), route: '/profilo', icon: IconUser },
  ]
  return (
    <View style={[sidebarStyles.sidebar, { backgroundColor: tc.bgCard, borderRightColor: tc.border }]}>
      <TouchableOpacity style={sidebarStyles.logoArea} onPress={() => router.push('/')}>
        <Image
          source={LOGO}
          style={sidebarStyles.logoImg}
          resizeMode="contain"
        />
        <View>
          <Text style={[sidebarStyles.logoV, { color: tc.text }]}>VIRTUA</Text>
          <Text style={[sidebarStyles.logoC, { color: brandColors.rosa }]}>CYCLING</Text>
        </View>
      </TouchableOpacity>

      <View style={{ paddingHorizontal: 4, paddingBottom: 12 }}><CompetitionSwitcher /></View>

      {leagueName && (
        <View style={[sidebarStyles.leagueBox, { backgroundColor: tc.bgCard2, borderColor: tc.border }]}>
          <Text style={[sidebarStyles.leagueLabel, { color: tc.textDim }]}>{t('nav.active_league').toUpperCase()}</Text>
          {userLeagues?.length > 1 ? (
            <View style={{ gap: 4 }}>
              {userLeagues.map(l => (
                <TouchableOpacity
                  key={l.id_league}
                  onPress={() => switchLeague(l.id_league)}
                  style={[
                    sidebarStyles.leagueItem,
                    leagueName === l.name && { backgroundColor: brandColors.rosaSubtle, borderRadius: 6 }
                  ]}
                >
                  <Text style={[
                    sidebarStyles.leagueName,
                    { color: leagueName === l.name ? brandColors.rosa : tc.text }
                  ]} numberOfLines={1}>
                    {l.name}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          ) : (
            <Text style={[sidebarStyles.leagueName, { color: tc.text }]} numberOfLines={1}>{leagueName}</Text>
          )}
        </View>
      )}

      <View style={sidebarStyles.nav}>
        {NAV_ITEMS.map(({ title, route, icon: Icon }) => {
          const active = isActive(route)
          return (
            <TouchableOpacity
              key={route}
              style={[
                sidebarStyles.navItem,
                active && { backgroundColor: brandColors.rosaSubtle, borderLeftColor: brandColors.rosa }
              ]}
              onPress={() => router.push(route)}
            >
              <Icon size={18} color={active ? brandColors.rosa : tc.textMuted} />
              <Text style={[
                sidebarStyles.navText,
                { color: active ? brandColors.rosa : tc.textMuted, fontWeight: active ? '700' : '400' }
              ]}>
                {title}
              </Text>
            </TouchableOpacity>
          )
        })}
      </View>

      <View style={[sidebarStyles.footer, { borderTopColor: tc.border }]}>
        <View style={sidebarStyles.footerUser}>
          <View style={[sidebarStyles.avatar, { backgroundColor: brandColors.rosa }]}>
            <Text style={[sidebarStyles.avatarText, { color: brandColors.brandText }]}>
              {nickname?.[0]?.toUpperCase() ?? '?'}
            </Text>
          </View>
          <Text style={[sidebarStyles.footerNick, { color: tc.text }]} numberOfLines={1}>{nickname}</Text>
        </View>
        <TouchableOpacity onPress={signOut} style={[sidebarStyles.logoutBtn, { borderColor: tc.border }]}>
          <Text style={[sidebarStyles.logoutText, { color: tc.textDim }]}>{t('common.logout')}</Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}

// ── AppShell ───────────────────────────────────────────────────────
function AppShell({ isDesktop, children }) {
  const tc = useThemeColors()
  return (
    <View style={[shellStyles.main, { backgroundColor: tc.bg }]}>
      {isDesktop && <DesktopSidebar />}
      <View style={shellStyles.content}>
        {children}
      </View>
    </View>
  )
}

export default function RootLayout() {
  const { width } = useWindowDimensions()
  const isDesktop = Platform.OS === 'web' && width > 1024

  const [fontsLoaded] = useFonts({
    BarlowCondensed_400Regular,
    BarlowCondensed_500Medium,
    BarlowCondensed_700Bold,
    BarlowCondensed_800ExtraBold,
    BebasNeue_400Regular,
    Orbitron_700Bold,
    DSEG7Classic_Bold: require('../assets/fonts/DSEG7Classic-Bold.ttf'),

  })

  useEffect(() => {
    if (fontsLoaded) SplashScreen.hideAsync()
  }, [fontsLoaded])

  // ─── Deep link listener per OAuth Google su mobile ────────────────
  useEffect(() => {
    if (Platform.OS === 'web') return

    const handleDeepLink = async ({ url }) => {
      if (!url) return
      if (url.includes('auth/callback') || url.includes('access_token') || url.includes('refresh_token')) {
        await supabase.auth.getSessionFromUrl({ url })
      }
    }

    // Link ricevuto mentre l'app è aperta
    const sub = Linking.addEventListener('url', handleDeepLink)

    // Link ricevuto all'apertura dell'app da deep link
    Linking.getInitialURL().then(url => {
      if (url) handleDeepLink({ url })
    })

    return () => sub.remove()
  }, [])

  if (!fontsLoaded) return <View style={{ flex: 1, backgroundColor: '#0D0D0D' }} />

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider>
        <ThemeProvider>
          <AuthProvider>
            <StatusBar style="auto" />
            <AppShell isDesktop={isDesktop}>
              <Stack screenOptions={{
                headerShown: false,
                contentStyle: { backgroundColor: '#0D0D0D' }
              }}>
                <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
              </Stack>
            </AppShell>
            <UpdatePrompt />
            <CompetitionTransition />
          </AuthProvider>
        </ThemeProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  )
}

const sidebarStyles = StyleSheet.create({
  sidebar: {
    width: 240,
    borderRightWidth: 1,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  logoArea: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  logoImg: { width: 36, height: 36, borderRadius: 8 },
  logoV: { fontSize: 16, fontFamily: 'BarlowCondensed_800ExtraBold', lineHeight: 18, letterSpacing: 1 },
  logoC: { fontSize: 13, fontFamily: 'BarlowCondensed_700Bold', letterSpacing: 2, lineHeight: 15 },
  leagueBox: { borderWidth: 1, borderRadius: 10, padding: 12, gap: 6 },
  leagueLabel: { fontSize: 9, fontFamily: 'BarlowCondensed_700Bold', letterSpacing: 2, textTransform: 'uppercase' },
  leagueName: { fontSize: 13, fontFamily: 'BarlowCondensed_700Bold' },
  leagueItem: { paddingHorizontal: 6, paddingVertical: 4 },
  nav: { flex: 1, gap: 2 },
  navItem: { flexDirection: 'row', alignItems: 'center', gap: 12, paddingVertical: 10, paddingHorizontal: 12, borderRadius: 8, borderLeftWidth: 3, borderLeftColor: 'transparent' },
  navText: { fontSize: 15, fontFamily: 'BarlowCondensed_700Bold', letterSpacing: 0.5 },
  footer: { borderTopWidth: 1, paddingTop: 16, gap: 10 },
  footerUser: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  avatar: { width: 32, height: 32, borderRadius: 16, alignItems: 'center', justifyContent: 'center' },
  avatarText: { fontSize: 13, fontFamily: 'BarlowCondensed_800ExtraBold' },
  footerNick: { flex: 1, fontSize: 13, fontFamily: 'BarlowCondensed_700Bold' },
  logoutBtn: { borderWidth: 1, borderRadius: 8, paddingVertical: 8, alignItems: 'center' },
  logoutText: { fontSize: 12, fontFamily: 'BarlowCondensed_500Medium' },
})

const shellStyles = StyleSheet.create({
  main: { flex: 1, flexDirection: 'row' },
  content: { flex: 1, maxWidth: 900, marginHorizontal: 'auto', width: '100%' },
})